(function() { module.exports = window["wc"]["blocksCheckout"]; }());